/**
 * Module Life Performance — conteneur principal (Fitness OS).
 *
 * Tant qu'aucun sport n'est paramétré, on présente l'activation ; ensuite la
 * navigation interne expose : Dashboard, Objectifs, Plans & Séances, Planning,
 * Coach, Réglages.
 *
 * Route : /performance (cf. App.js).
 */
import React, { useEffect, useState } from 'react'
import { Box, Container, IconButton, Stack, Tab, Tabs, Typography } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import BoltRoundedIcon from '@mui/icons-material/BoltRounded'
import { useNavigate } from 'react-router-dom'

import { performanceApi } from '../api/performanceApi'
import { Loading, PAGE_BG, PERF_ACCENT } from './shared'
import OnboardingView from './OnboardingView'
import DashboardView from './DashboardView'
import GoalsView from './GoalsView'
import PlansView from './PlansView'
import ActivitiesView from './ActivitiesView'
import PlanningView from './PlanningView'
import CoachView from './CoachView'
import SettingsView from './SettingsView'

const TABS = [
  { label: 'Dashboard', render: () => <DashboardView /> },
  { label: 'Objectifs', render: () => <GoalsView /> },
  { label: 'Plans & Séances', render: () => <PlansView /> },
  { label: 'Activités', render: () => <ActivitiesView /> },
  { label: 'Planning', render: () => <PlanningView /> },
  { label: 'Coach', render: () => <CoachView /> },
  { label: 'Réglages', render: () => <SettingsView /> },
]

export default function PerformanceModule() {
  const navigate = useNavigate()
  const [overview, setOverview] = useState(null)
  const [loading, setLoading] = useState(true)
  const [tab, setTab] = useState(0)

  const loadOverview = async () => {
    setLoading(true)
    const o = await performanceApi.getOverview()
    setOverview(o)
    setLoading(false)
  }

  useEffect(() => {
    loadOverview()
    window.scrollTo(0, 0)
  }, [])

  const hasSports = overview && overview.sports > 0

  return (
    <Box sx={{ bgcolor: PAGE_BG, minHeight: '100vh', pb: 6 }}>
      <Container maxWidth="lg" sx={{ pt: 3 }}>
        <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 2 }}>
          <IconButton onClick={() => navigate('/')} sx={{ color: '#fff' }}>
            <ArrowBackIcon />
          </IconButton>
          <BoltRoundedIcon sx={{ color: PERF_ACCENT }} />
          <Typography sx={{ color: '#fff', fontWeight: 800, fontSize: 22 }}>
            Life Performance
          </Typography>
        </Stack>

        {loading ? (
          <Loading label="Ouverture de votre espace performance…" />
        ) : !hasSports ? (
          <OnboardingView onDone={loadOverview} />
        ) : (
          <>
            <Tabs
              value={tab}
              onChange={(_, v) => setTab(v)}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                mb: 3,
                '& .MuiTab-root': {
                  color: 'rgba(255,255,255,0.55)',
                  textTransform: 'none',
                  fontWeight: 600,
                },
                '& .Mui-selected': { color: `${PERF_ACCENT} !important` },
                '& .MuiTabs-indicator': { backgroundColor: PERF_ACCENT },
              }}
            >
              {TABS.map((t) => (
                <Tab key={t.label} label={t.label} />
              ))}
            </Tabs>
            {TABS[tab].render()}
          </>
        )}
      </Container>
    </Box>
  )
}
